<template>
    <div id="covid-page">

        <section-banner-small :picture-url="picture" :title="name"></section-banner-small>

        <!-- Content Section -->
        <section class="section-style">
            <div data-aos="fade-left"
                 data-aos-offset="100"
                 data-aos-once="true"
                 data-aos-duration="500">

                <div class="container padding-right-left-0">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-10">
                            <div class="box-form bg-white box-shadow rounded text-justify">
                                <!--<div id="wizehire-jobroll-container"></div>
                                <noscript><a href="https://wizehire.com">Jobs</a> by WizeHire</noscript>-->
                                <h3 class="font-md">
                                    <a href="https://wizehire.com/job/account-executive-luxury-travel-in-aventura-fl-us-4cec6175437de184?utm_source=jobroll&utm_medium=feed&utm_campaign=partners" target="_blank" class="link-style font-weight-bold">
                                        Account Executive - Luxury Travel
                                    </a>
                                </h3>
                                <p class="margin-top-30">
                                    <strong>Ultimate Jet Vacations - Aventura, FL, US</strong>
                                </p>
                                <p>
                                    This role is for people who are looking to build a career and a chance to be paid based on merit,
                                    the more you sell, the more you make. You need to be a natural people person, you have to be…
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>

    </div>
</template>

<script>

    import SectionBannerSmall from "./../components/sections/BannerSmall";
    export default {
        components: {SectionBannerSmall},
        data: function () {
            return {
                name: 'Career Opportunities',
                picture: "/assets/bg/about-us-bg.jpeg"
            };
        },
        /*mounted() {
            let script = document.createElement('script');
            script.src = 'https://wizehire.com/jobroll/v1/bootstrap/12028/jobroll.js?exclude_subaccounts=1';
            script.async = true;
            let entry = document.getElementsByTagName('script')[0];
            entry.parentNode.insertBefore(script, entry);
        },*/
    };

</script>

<style lang="scss">
    /** Unique Index Styles **/
</style>
